<template>
    <rkm-layout-body title="Lista de vacina">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-vacina-create' })"
                authorize="store-cadastro-vacina"
                color="primary"
            >
                Cadastrar vacina
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/cadastro/vacina/List'

export default {
    components: { List },
}
</script>